import { render, staticRenderFns } from "./registrationSearch.vue?vue&type=template&id=4f7b0040&lang=pug"
import script from "./registrationSearch.vue?vue&type=script&lang=js"
export * from "./registrationSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_82f4f5227389e3f7a8a9ca9213a48706/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports